import Api from "../axios";

export const getLeaderboard = async (data) => {
  let res = await Api.post(`Game/GlGetLeaderBoard`,data);
  let json = JSON.parse(res.data.d)
  return json.Table
};
